/**
 * Utilities
 */
(function( $ )
{
	"use strict";
	
	window.theme = window.theme || {};

	// https://stackoverflow.com/a/4541963
	var waitForFinalEvent = (function()
	{
		var timers = {};
		
		return function( callback, ms, uniqueId ) 
		{
			if ( ! uniqueId )
			{
				uniqueId =  "Don't call this twice without a uniqueId";
			};

			if ( timers[ uniqueId ] )
			{
				clearTimeout( timers[ uniqueId ] );
			};

			timers[ uniqueId ] = setTimeout( callback, ms );
		};
	})();

	var trailingslashit = function( url )
	{
		var lastChar = url[ url.length -1 ];

		if ( lastChar != '/' ) 
		{
			url += '/';
		}

		return url;
	};

	theme.waitForFinalEvent = waitForFinalEvent;
	theme.trailingslashit   = trailingslashit;

})( jQuery );
